import Auth from './auth.js'
import Api from './lib/api.js';
import DlgPrivacy from './lib/privacy.js'
import IVPLoader from './lib/loader.js'

document.addEventListener("DOMContentLoaded",async()=>{

    document.querySelector("#sidebar-menu .operators").classList.add("active")
    document.querySelector(".navbar-header .breadcrumb").append($(`<li class="breadcrumb-item active">Operatori</li>`)[0])
    
    IVPLoader.Show()

    if (await Auth.Init() == false)
        return

    if (Auth.user.privacy_accepted == false)
        await DlgPrivacy.EnsureAccepted()

    // Default Datatable
    let resp = await Api.GetOperators()
    let btb = $('#basic-datatable').DataTable({
        buttons: [
            'copy', 'excel', 'pdf'

        ],
        "pageLength": 50,
        "language": {
            "paginate": {
                "previous": "<i class='mdi mdi-chevron-left'>",
                "next": "<i class='mdi mdi-chevron-right'>"
            },
            processing:     "Elaborazione dati...",
            search:         "Ricerca&nbsp;:",
            lengthMenu:    "Visualizza _MENU_ record",
            info:           "Visualizzati da _START_ a _END_ di _TOTAL_ record",
            infoEmpty:      "Nessun record in archivio",
            infoFiltered:   "(trovati su _MAX_ in totale)",
            infoPostFix:    "",
            loadingRecords: "Caricamento dati...",
            zeroRecords:    "Nessun record",
            emptyTable:     "Archivio vuoto",
            sortAscending:  ": activer pour trier la colonne par ordre croissant",
            sortDescending: ": activer pour trier la colonne par ordre décroissant"
        },

        columns: [                        
            { title: 'Nome', data: 'login' },
            { title: 'Pratiche assegnate', data: 'yards_total_count' },
            { title: 'Pratiche non iniziate', data: 'yards_empty_count' },            
            { title: 'Pratiche in lavorazione', data: 'yards_started_count' },
            { title: 'Pratiche approvate', data: 'yards_approved_count' },
            { title: 'Media richieste integrazioni', data: 'average_integrations_per_yard' },            
            // { title: 'Pratiche in GENERALE', data: 'yards_general_count' },
            // { title: 'Pratiche in CONDOMINI', data: 'yards_tenants_count' },
            // { title: 'Pratiche in ACCONTO', data: 'yards_advance_count' },
            { title: ' ', data: '' },
        ],
         
        columnDefs: [
            {   
                targets: [3],
                render: function (data, type, row) {
                    return `${row.yards_started_count} [ ${row.yards_started_count-row.yards_tenants_count-row.yards_advance_count}, ${row.yards_tenants_count}, ${row.yards_advance_count} ]`
                },
                
            },
            {   
                targets: [5],
                render: function (data, type, row) {
                    return parseFloat(data).toFixed(2)
                },
                
            },            
            {   
                targets: [-1],
                width: 100,
                render: function (data, type, row) {
                    return "<button type='button' class='btnEdit btn btn-outline-secondary btn-sm'>Modifica</button>";   
                },
                
            },
        ],
        data: resp,
        buttons: [
            'excel', {
                extend: 'pdfHtml5',
                orientation: 'landscape',
                pageSize: 'A4',
                exportOptions: {
                    columns: ':not(:last-child)',
                },
                footer: true 
            }
        ],
        drawCallback: function () {
            var api = this.api();
            $("#basic-datatable tfoot .yards_total_count").html(api.column( 1, {page:'current'} ).data().sum())
            $("#basic-datatable tfoot .yards_empty_count").html(api.column( 2, {page:'current'} ).data().sum())
            $("#basic-datatable tfoot .yards_started_count").html(api.column( 3, {page:'current'} ).data().sum())
            $("#basic-datatable tfoot .yards_approved_count").html(api.column( 4, {page:'current'} ).data().sum())
        },
        initComplete: function () {
            var api = this.api();
            let f = $('<tfoot/>')
            f.append($(`<th>&nbsp</th>`))
            f.append($(`<th class="yards_total_count">0</th>`))
            f.append($(`<th class="yards_empty_count">0</th>`))
            f.append($(`<th class="yards_started_count">0</th>`))
            f.append($(`<th class="yards_approved_count">0</th>`))
            f.append($(`<th>&nbsp</th>`))
            f.append($(`<th>&nbsp</th>`))

            $("#basic-datatable").append(f)
            api.table().draw()
        }        
    });
    btb.buttons().container()
    .appendTo($("#table-buttons"))

    let fnEdit = ()=> {
        $("#basic-datatable .btnEdit").off('click')
        $("#basic-datatable .btnEdit").click((e)=>{
            let tr = btb.row(e.target.closest('tr'))
            document.location.href = "operator.html?id="+tr.data().id
            console.log(tr.data())
        })
    }

    fnEdit()    
    btb.on( 'draw init.dt', fnEdit)
    
    $(".btnAdd").click((e)=>{        
        document.location.href = "operator.html?id="+(-1) 
    })
    
    document.querySelector(".page-content").classList.remove("hidden")

    IVPLoader.Remove()
})